import { supabaseServerClient } from "@supabase/supabase-auth-helpers/nextjs";
import { PaperAirplaneIcon } from "@heroicons/react/outline";
import { handle, json } from "next-runtime";
import { Form, useFormSubmit } from "next-runtime/form";
import toast from "react-hot-toast";
import Image from "next/image";

export const getServerSideProps = handle({
  get: () => json({}),
  post: async (ctx) => {
    try {
      const { body } = ctx.req;
      const email = body?.email as string;
      const { error } = await supabaseServerClient(ctx).auth.signIn({ email });
      if (error) throw error;
      return json({ message: "Check your email for the login link!" });
    } catch (error) {
      return json(
        {
          message: (error as any).error_description ?? (error as any).message,
        },
        400
      );
    }
  },
});

export default function SignIn() {
  const { isLoading } = useFormSubmit("signin");
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <img
            className="mx-auto h-12 w-auto"
            src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg"
            alt="Workflow"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in with your email below
          </h2>
        </div>
        <Form
          name="signin"
          className="mt-8 space-y-6"
          method="post"
          encType="multipart/form-data"
          onSuccess={() => {
            toast.success("Check your email for the login link!");
          }}
          onError={({ error }) => {
            toast.error(
              (error as any)?.data.message ?? "Unable to send magic link"
            );
          }}
        >
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Email address"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              disabled={isLoading}
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <PaperAirplaneIcon
                  className="h-5 w-5 text-blue-300 group-hover:text-blue-400"
                  aria-hidden="true"
                />
              </span>
              {isLoading ? "Loading..." : "Send magic link"}
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
}
